(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.FiAklaCustomerDetails = api;
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  function normalizePhone(value) {
    var compact = String(value || '').trim().replace(/[٠-٩۰-۹]/g, function (digit) {
      return String(digit.charCodeAt(0) - (digit >= '۰' ? 1776 : 1632));
    }).replace(/[\s()-]/g, '');
    if (/^01[0125]\d{8}$/.test(compact)) return '+2' + compact;
    if (/^00201[0125]\d{8}$/.test(compact)) return '+' + compact.slice(2);
    if (/^\+201[0125]\d{8}$/.test(compact)) return compact;
    return '';
  }

  function isGoogleMapsPin(value) {
    try {
      var url = new URL(String(value || '').trim());
      var host = url.hostname.toLowerCase();
      return url.protocol === 'https:' && (
        host === 'maps.app.goo.gl' ||
        host === 'goo.gl' ||
        host === 'maps.google.com' ||
        host === 'www.google.com' && url.pathname.indexOf('/maps') === 0 ||
        host === 'google.com' && url.pathname.indexOf('/maps') === 0
      );
    } catch (_) {
      return false;
    }
  }

  function validate(value) {
    return !!(
      value && value.area && value.zone && String(value.address || '').trim().length >= 8 &&
      isGoogleMapsPin(value.pin) && normalizePhone(value.phone)
    );
  }

  return { normalizePhone: normalizePhone, isGoogleMapsPin: isGoogleMapsPin, validate: validate };
});

